import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { Form, FormGroup } from "react-bootstrap";
import _ from "lodash";
import Button from "../../../../components/common/button/Button";
import styles from "./AdminCompanyEdit.scss";
import Input from "../../../../components/common/input/Input";
import Select2 from "../../../../components/common/select/Select2";
import Textarea from "../../../../components/common/textarea/Textarea";
import Typeahead from "../../../../components/common/typeahead/Typeahead";
import {
  required,
  dropdown,
  maxLength
} from "../../../../utils/forms/validators";
import * as userActions from "../../../../actions/user.actions";
import * as companyActions from "../../../../actions/company.actions";
import ScrollToTopOnMount from "../../../../utils/scroll/ScrollToTopOnMount";
import { EDIT_EMPLOYER_PROFILE_FORM } from "../../../../actions/user.actions";

const dropdownValidation = msg => dropdown(msg);
const maxLengthValidation = (max, msg) => maxLength(max, msg);

const industry = dropdownValidation("Please select an Industry.");
const companySize = dropdownValidation("Please select a Company Size.");
const summary = maxLengthValidation(
  280,
  "Summary must be less than or equal to 280 characters."
);

class AdminCompanyEditContainer extends Component {
  componentDidMount() {
    this.props.companyActions.getAdminCompanyById(this.props.companyId);
  }

  render() {
    const {
      handleSubmit,
      submitting,
      valid,
      cities,
      onSearchCities,
      isLoading,
      industries,
      companySizes
    } = this.props;

    const selectedCityProps = {};
    if (this.props.defaultLocation) {
      selectedCityProps.selected = [this.props.defaultLocation];
    }

    return (
      <section className={styles.adminCompanyEditContainer}>
        <ScrollToTopOnMount />
        <div className={styles.content}>
          <h2 className={styles.title}>Edit Company Information</h2>

          <Form onSubmit={handleSubmit}>
            <div className={styles.form}>
              <FormGroup />
              <FormGroup>
                <Field
                  name="company"
                  placeholder="Company Name"
                  component={Input}
                  validate={[required]}
                />

                <Field
                  name="industry_id"
                  type="select"
                  placeholder="Industry"
                  component={Select2}
                  options={industries}
                  validate={industry}
                />

                <Field
                  name="company_size_id"
                  type="select"
                  placeholder="Company Size"
                  component={Select2}
                  options={companySizes}
                  validate={companySize}
                />

                <Field
                  name="location"
                  type="text"
                  placeholder="Office Location (City, State)"
                  component={Typeahead}
                  isLoading={isLoading || false}
                  options={cities}
                  isAsync={true}
                  minLength={3}
                  allowNew={false}
                  labelKey="description"
                  valueKey="id"
                  icon="map-marker"
                  validate={required}
                  focusOut={selected => {
                    if (!selected) {
                      this.props.change("location", null);
                    }
                  }}
                  onSearch={query => onSearchCities(query)}
                  {...selectedCityProps}
                />

                <Field
                  name="url"
                  type="text"
                  placeholder="Website or LinkedIn Page"
                  component={Input}
                  validate={required}
                />

                <Field
                  name="summary"
                  type="textarea"
                  placeholder="Describe your company to prospective
                  freelancers and employees (you can edit this later)."
                  component={Textarea}
                  help={"Please enter a brief description of your company."}
                  maxlength={280}
                  label="Company Summary"
                  validate={[summary]}
                />

                <Button
                  isPrimary
                  type="submit"
                  size={"large"}
                  label="Save Changes"
                  isDisabled={!valid || submitting}
                />
              </FormGroup>
            </div>
          </Form>
        </div>
      </section>
    );
  }
}

AdminCompanyEditContainer = reduxForm({
  form: EDIT_EMPLOYER_PROFILE_FORM,
  enableReinitialize: true,
  touchOnBlur: true,
  touchOnChange: true
})(AdminCompanyEditContainer);

const selector = formValueSelector(EDIT_EMPLOYER_PROFILE_FORM);
AdminCompanyEditContainer = connect(
  state => {
    const company = state.company.adminCompany;
    const defaultLocation = selector(state, "location");
    return {
      company,
      defaultLocation,
      initialValues: {
        company: _.get(company, "name"),
        industry_id: _.get(company, "industry_id"),
        company_size_id: _.get(company, "company_size_id"),
        location: _.get(company, "location"),
        url: _.get(company, "url"),
        summary: _.get(company, "summary")
      }
    };
  },
  dispatch => ({
    userActions: bindActionCreators(userActions, dispatch),
    companyActions: bindActionCreators(companyActions, dispatch)
  })
)(AdminCompanyEditContainer);

export default AdminCompanyEditContainer;



// WEBPACK FOOTER //
// ./src/routes/admin/company/components/AdminCompanyEdit.js